import type { ReactionsResults } from '@mentimeter/http-clients';
import { core } from '@mentimeter/http-clients';
import { mutate } from 'swr';
import { reactionsResultsCacheKey } from './cache-keys';
import type { UseReactionsResults } from './types';
import { useData } from './use-data';

export const useReactionsResults: UseReactionsResults = (
  seriesId,
  questionId,
  config,
) => {
  const cacheKey = questionId
    ? reactionsResultsCacheKey(questionId)
    : undefined;
  const { data, error, revalidate, lazyData } = useData<
    ReactionsResults | undefined
  >(
    {
      cacheKey,
      seriesId,
      fetcher: async (...arg) => {
        if (!questionId) return undefined;
        const { data } =
          await core().presentation.reactions.results.get(questionId);
        return data;
      },
    },
    config,
  );

  return {
    data,
    error,
    revalidate,
    lazyData,
  };
};

export const revalidateReactionsResults = (questionId: string) => {
  const cacheKey = reactionsResultsCacheKey(questionId);
  mutate(cacheKey);
};
